import * as React from "react";
import { Avatar } from "primereact/avatar";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MailIcon from "@mui/icons-material/Mail";

import MenuIcon from "@mui/icons-material/Menu";
import { useState, useRef } from "react";
// import { Test } from "./pages/test/test";
import "primeicons/primeicons.css";
import { Toast } from "primereact/toast";
// import { Test } from "./pages/test/test";
import { Logout } from "./pages/logout/logoutPage/logout";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Logo from "./assets/logo.png";
import Navbar from "./component/Navbar";
import NavbarGauche from "./component/NavbarGauche";
import "./App.css";

import { Link, useLocation } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Login } from "./pages/login/loginPage/login";
import { Stockage } from "./pages/stockage/stockage";
import { StockageRetard } from "./pages/stockageRetard/stockageRetard";
import { Client } from "./pages/client/ClientPage/client";
import { Reglement } from "./pages/reglement/reglementPage/Reglement";
import { Users } from "./pages/users/usersPage/users";
import { Contrat } from "./pages/contrat/contratPage/contrat";

import Tasklist from "./pages/tasklist/tasklist";
import FicheListe from "./pages/fiche/fiche";
import FicheDemandeListe from "./pages/ficheDemande/ficheDem";

import { Dash } from "./pages/dashboard/dashboardPage/dash";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LocationStockage } from "./pages/location/locationPage/locationStockage";
import { ToastContainer } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect } from "react";
import { Facture } from "./pages/facture/facturePage/facture";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import "./styles/NavbarGauche.css";
import { Modal } from "@mui/material";
// import { Menu } from "primereact/menu";
import ReactDOM from "react-dom";

import LeadsList from "./pages/leads/leads";



import "primeflex/primeflex.css";




const drawerWidth = 240;
function App(props) {
  const isMobilePortrait = useMediaQuery("(max-width:1400px) ");

  const [nomPageActive, setNomPageActive] = useState("");
  const locationGauche = useLocation();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();
  // const menu = useRef(null);

  const [menuOpen, setMenuOpen] = useState(false);
const menuRef = useRef(null);

useEffect(() => {
  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setMenuOpen(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);


  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  let items = [
  
    {
      label: "Déconnexion",
      icon: "pi pi-power-off",
      command: () => {
        setdeconnect(true);
      },
    },
  ];
  if (localStorage.getItem("us") === "admin") {
    items.unshift({
      label: "Utilisateurs",
      icon: "pi pi-users",
      command: () => {
        navigate("/users");
      },
    });
  }
  

  const [deconnectHovered, setDeconnectHovered] = useState(false);

  const [deconnect, setdeconnect] = useState(false);

  // const handleAvatarClick = (event) => {
  //   menu.current.toggle(event);
  // };

  const drawer = (
    <div>
      <Divider />

      <div className="navbarGauche">
        <Link
          to="/"
          onClick={() => {
            setNomPageActive("TABLEAU DE BORD");
          }}
        >
          <img
            src={Logo}
            alt="Logo"
            style={{
              marginLeft: "5%",
              width: "100px",
              display: "block",
            }}
          />
        </Link>

        {/* <div className="divLink">
          <Link
            to="/"
            className={locationGauche.pathname === "/" ? "activeLink" : "ty"}
            onClick={() => setNomPageActive("TABLEAU DE BORD")}
          >
            <i className="pi pi-chart-pie"></i> <strong>Tableau de bord</strong>
          </Link>
        </div>

        <div className="divLink">
          <Link
            to="/stockage"
            className={
              locationGauche.pathname === "/stockage" ? "activeLink" : "ty"
            }
            onClick={() => setNomPageActive("PLAN DU SITE")}
          >
            <i className="pi pi-sitemap"></i> <strong>Plan du site</strong>
          </Link>
        </div> 

        <div className="divLink">
          <Link
            to="/client"
            className={
              locationGauche.pathname === "/client" ? "activeLink" : "ty"
            }
            onClick={() => setNomPageActive("CLIENTS")}
          >
            <i className="pi pi-users"></i> <strong>Clients</strong>
          </Link>
        </div>

        <div className="divLink">
          <Link
            to="/tasklist"
            className={
              locationGauche.pathname === "/tasklist" ? "activeLink" : "ty"
            }
            onClick={() => setNomPageActive("Listes des tâches")}
          >
            <i
              className="pi pi-check-square"
              style={{ marginRight: "2px" }}
            ></i>
            <strong>Tâches</strong>
          </Link>
        </div>

        <div className="divLink">
          <Link
            to="/fiche"
            className={
              locationGauche.pathname === "/fiche" ? "activeLink" : "ty"
            }
            onClick={() => setNomPageActive("Fiches stock")}
          >
            <i className="pi pi-box" style={{ marginRight: "4px" }}></i>
            <strong>Fiches stock</strong>
          </Link>
        </div>
*/}

        <div className="divLink">
          <Link
            to="/LeadsList"
            className={
              locationGauche.pathname === "/LeadsList" ? "activeLink" : "ty"
            }
            onClick={() => setNomPageActive("Fiche dem")}
          >
            <i className="pi pi-calendar" style={{ marginRight: "4px" }}></i>
            <strong>Leads</strong>
          </Link>
        </div>



      </div>

      <Divider />
    </div>
  );
  const toast = useRef(null);
  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {" "}
      <Box sx={{ display: "flex" }}>
        <ToastContainer />
        <Toast ref={toast} />
        <CssBaseline />
        <AppBar
          position="fixed"
          elevation={0}
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Toolbar
            style={{
              backgroundColor: "#d9c4a3",
              color: "#ffffff",
              justifyContent: "space-between",
              gap: "20px",
            }}
          >
            <div style={{ display: "flex", float: "left", left: "0" }}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2, display: { sm: "none" } }}
              >
                <MenuIcon />
              </IconButton>
            </div>

<div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >

          <div style={{ position: "relative" }} ref={menuRef}>
  <Tooltip title={localStorage.getItem("us")} arrow>
    <span style={{ cursor: "pointer" }} onClick={() => setMenuOpen(!menuOpen)}>
      <Avatar
        shape="circle"
        style={{ backgroundColor: "#5b3b32", color: "#dac4a3" }}
      >
        {localStorage.getItem("us")?.charAt(0)}
      </Avatar>
    </span>
  </Tooltip>

  {menuOpen && (
    <div
      style={{
        position: "absolute",
        right: 0,
        top: "60px",
        backgroundColor: "#f5f5f5",
        boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
        borderRadius: "6px",
        color: "#070707",
        zIndex: 1000,
        minWidth: "160px",
        overflow: "hidden",
      }}
    >
      {items.map((item, index) => (
        <div
          key={index}
          onClick={() => {
            item.command?.();
            setMenuOpen(false);
          }}
          style={{
            padding: "10px 16px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontSize: "14px",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f5f5f5")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
        >
          {item.icon && <i className={item.icon} />}
          {item.label}
        </div>
      ))}
    </div>
  )}
</div>

              <Modal
                open={deconnect}
                disableBackdropClick={true}
                aria-describedby="modal-modal-description"
              >
                <Logout onClose={() => setdeconnect(false)} />
              </Modal>
            </div>




          </Toolbar>
        </AppBar>
        <Box
          component="nav"
          sx={{
            width: { sm: drawerWidth },
            flexShrink: { sm: 0 },
          }}
          aria-label="mailbox folders"
        >
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            style={{ overflow: " hidden" }}
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: "auto",
                height: "auto",
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 2,
            p: 3,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          <Toolbar />

          <Routes>
            <Route path="/login" element={<Login />} />
            {/* <Route path="/facture" element={<Facture />} /> */}
            {/* <Route path="/" element={<Dash />} /> */}

 <Route path="/" element={<LeadsList />} /> 




            {isMobilePortrait ? null : (
              <>
                <Route path="/stockage" element={<Stockage />} />
                <Route path="/stockageRetard" element={<StockageRetard />} />
                <Route path="/client" element={<Client />} />
              </>
            )}
            {/* <Route path="/location" element={<LocationStockage />} />
            <Route path="/reglementListe" element={<Reglement />} />
            <Route path="/contrat" element={<Contrat />} />
            <Route path="/tasklist" element={<Tasklist />} />
            <Route path="/fiche" element={<FicheListe />} /> */}

            {/* <Route path="/ficheDem" element={<FicheDemandeListe />} />
            <Route path="/users" element={<Users />} />
            <Route path="/facture" element={<Facture />} /> */}

             <Route path="/LeadsList" element={<LeadsList />} />
          </Routes>
        </Box>
        {isMobilePortrait ? (
          <>
            <Box
              sx={{
                flexGrow: 1,
                p: 3,
                marginLeft: `-${drawerWidth}px`,
              }}
            >
              <Toolbar />
              <Routes>
                <Route path="/stockage" element={<Stockage />} />{" "}
              </Routes>
            </Box>
          </>
        ) : null}{" "}
        {isMobilePortrait ? (
          <>
            <Box
              sx={{
                flexGrow: 1,
                p: 3,
                marginLeft: `-95px`,
              }}
            >
              <Toolbar />
              <Routes>
                <Route path="/stockageRetard" element={<StockageRetard />} />{" "}
              </Routes>
            </Box>
          </>
        ) : null}{" "}
        {isMobilePortrait ? (
          <>
            <Box
              sx={{
                flexGrow: 1,
                p: 3,
                // marginLeft: `-${drawerWidth}px`,
              }}
              style={{ width: "90vw" }}
            >
              <Toolbar />
              <Routes>
                <Route path="/client" element={<Client />} />{" "}
              </Routes>
            </Box>
          </>
        ) : null}
      </Box>
    </LocalizationProvider>
  );
}

App.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * Remove this when copying and pasting into your project.
   */
  window: PropTypes.func,
};

export default App;
